/**
 * # ⛓️ CURSOR_ANCHOR:ui:search-form-border-radius
 * Управление border-radius формы поиска
 * При ширине экрана >= 991px и когда активный язык - последний элемент,
 * устанавливает border-top-right-radius: 0, иначе восстанавливает исходное значение
 */

(function() {
  'use strict';

  /**
   * Обновляет border-radius формы поиска в зависимости от активной языковой вкладки
   */
  function updateSearchFormBorderRadius() {
    var searchForm = document.getElementById('search-form');
    if (!searchForm) {
      return;
    }
    
    // Проверяем ширину экрана
    var isLargeScreen = window.innerWidth >= 991;
    
    // Проверяем, является ли активный язык последним элементом
    var langLinks = document.querySelectorAll('#langs a:not(.langs-book-icon)');
    if (langLinks.length === 0) {
      return; // Если нет языковых вкладок, выходим
    }
    
    var activeLangIndex = -1;
    var lastLangIndex = langLinks.length - 1;
    
    langLinks.forEach(function(link, index) {
      if (link.classList.contains('active')) {
        activeLangIndex = index;
      }
    });
    
    // Если активная вкладка не найдена, выходим
    if (activeLangIndex === -1) {
      return;
    }
    
    var isLastLangActive = activeLangIndex === lastLangIndex;
    
    // Применяем стили в зависимости от условий
    if (isLargeScreen && isLastLangActive) {
      // Устанавливаем border-top-right-radius: 0
      searchForm.style.borderTopRightRadius = '0';
    } else {
      // Восстанавливаем исходное значение из CSS (удаляем inline стиль)
      searchForm.style.borderTopRightRadius = '';
    }
  }

  // Экспортируем функцию глобально для использования в других модулях
  window.updateSearchFormBorderRadius = updateSearchFormBorderRadius;
})();










